import useTheme from '../../hooks/useTheme';
import { darkTheme, lightTheme } from '../../theme/theme';
import './LoadingSpinner.css';

const LoadingSpinner = ({ overlay = false }) => {
    const [isDark] = useTheme();
    const theme = isDark ? darkTheme : lightTheme;

    const spinner = (
        <div className="loader" style={{
            '--button': theme.button,
            '--spinner': theme.spinner
        }}></div>
    );

    if (overlay) {
        return (
            <div className="absolute inset-0 z-[500] flex items-center justify-center" style={{ backgroundColor: theme.background1 }}>
                {spinner}
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center h-full">
            {spinner}
        </div>
    );
};

export default LoadingSpinner;
